import React from 'react'
import { useParams } from 'react-router-dom'
import VendorList from '../../components/vendor/VendorList'
import AddVendor from '../../components/vendor/AddVendor'

const Vendor = () => {
    let { method } = useParams();

    return (
        <>
            {method == "add" && <AddVendor />}
            {method == "list" && <VendorList />}
        </>
    )
}

export default Vendor
